import React from 'react';
import { Box, Button } from '@mui/material';
import { Add } from '@mui/icons-material';
import { ConditionGroup } from './ConditionGroup';
import { ConditionBuilder } from './ConditionBuilder';
import type { LogisticsObjectScope } from '@/types/logisticsObject';
import { QueryExpression } from '@/api/bol';

export interface VisualQueryBuilderProps {
  query: QueryExpression;
  onChange: (query: QueryExpression) => void;
  disabled?: boolean;
  logisticsObjectType?: LogisticsObjectScope;
}

export const VisualQueryBuilder: React.FC<VisualQueryBuilderProps> = ({
  query,
  onChange,
  disabled = false,
  logisticsObjectType = 'all'
}) => {
  const queryToCheck = query.not || query;
  const hasGroupOperator = queryToCheck.and || queryToCheck.or;

  const handleConvertToGroup = () => {
    // Convert single condition to an AND group
    onChange({
      and: [{ ...query }, {}]
    });
  };

  // If query has no group operator (and/or), show it as a single condition
  if (!hasGroupOperator) {
    return (
      <Box sx={{ p: 1 }}>
        <ConditionBuilder
          query={query}
          onChange={onChange}
          disabled={disabled}
          showRemoveButton={false}
          logisticsObjectType={logisticsObjectType}
        />
        <Box sx={{ mt: 1.5 }}>
          <Button
            startIcon={<Add />}
            onClick={handleConvertToGroup}
            disabled={disabled}
            size="small"
            variant="outlined"
          >
            Add Another Condition (Convert to Group)
          </Button>
        </Box>
      </Box>
    );
  }

  // Root is a group
  return (
    <Box sx={{ p: 1 }}>
      <ConditionGroup
        query={query}
        onChange={onChange}
        disabled={disabled}
        depth={0}
        showRemoveButton={false}
        logisticsObjectType={logisticsObjectType}
      />
    </Box>
  );
};
